<div
  class="flex w-full items-center justify-between h-[56px] border-b border-proffeo-overlay-subtle bg-proffeo-surface hover:bg-proffeo-surface-hover transition-colors"
>
  <div class="flex w-[70%] md:w-[60%] gap-1 items-center pl-2">
    @if (dangerousSituationVisible) {
      <mat-icon
        click
        toggleChildren
        fontIcon="keyboard_arrow_up"
        class="cursor-pointer hover:icon-accent transition icon-xl icon-muted"
      />
    }

    @if (!dangerousSituationVisible && oshAnalysis()?.dangerousSituations?.length > 0) {
      <mat-icon
        click
        toggleChildren
        fontIcon="keyboard_arrow_down"
        class="cursor-pointer hover:icon-accent transition icon-xl icon-muted"
      />
    }

    <p class="truncate text-proffeo-text max-sm:max-w-30 max-sm:text-xs">
      {{ oshAnalysis()?.workType?.value }}
    </p>
  </div>

  <mat-icon
    [matMenuTriggerFor]="matUserMenu"
    fontIcon="more_vert"
    class="cursor-pointer hover:icon-accent transition icon-muted"
  />

  <mat-menu #matUserMenu>
    <div class="flex h-full w-full flex-col">
      <div
        (click)="editAnalysis(oshAnalysis())"
        class="flex cursor-pointer w-full gap-1 items-center px-4 py-2 hover:bg-proffeo-surface-hover transition-colors"
      >
        <mat-icon
          fontIcon="edit"
          class="icon-md icon-muted"
        />
        <p>{{ 'osh.edit' | translate }}</p>
      </div>

      <div
        (click)="deleteAnalysis(oshAnalysis())"
        class="flex cursor-pointer w-full gap-1 items-center px-4 py-2 hover:bg-proffeo-feedback-error-surface transition-colors"
      >
        <mat-icon
          fontIcon="delete_outline"
          class="icon-md icon-danger"
        />
        <p class="text-proffeo-error">{{ 'osh.delete' | translate }}</p>
      </div>
    </div>
  </mat-menu>
</div>

@if (oshAnalysis()?.dangerousSituations?.length > 0 && dangerousSituationVisible) {
  <div class="flex flex-col gap-2 mt-3 ml-5 pl-4">
    @for (dangerousSituation of oshAnalysis()?.dangerousSituations; track dangerousSituation?.id) {
      <div class="w-full rounded-md">
        <proffeo-osh-dangerous-situation-item
          [dangerousSituation]="dangerousSituation"
          class="bg-proffeo-surface-muted"
        ></proffeo-osh-dangerous-situation-item>
      </div>
    }
  </div>
}
